<template>
    <div>
        <p class="text-center mb-4">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>

        <div class="bordas" v-if="leitoTransferencia != null">
            <p class="text-center  text-danger"><strong>DE:</strong></p>
            <p class="text-center mb-0"><strong>Enfermaria:</strong> {{leitoTransferencia.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{leitoTransferencia.leitoCodigo}}</p>
            <p class="text-center mb-0"><strong>{{leitoTransferencia.leitoNomeEnfermaria}}</strong></p>
            <p class="text-center mt-2 mb-0">Última movimentação: {{leitoTransferencia.dataHoraUltimaMovimentacao}}</p>
        </div>

        <div class="bordas mt-2">
            <p class="text-center text-danger"><strong>PARA:</strong></p>
            <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
            <p class="text-center mb-0"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>
            <p class="text-center mt-2 mb-0">Última movimentação: {{dados.dataHoraUltimaMovimentacao}}</p>
        </div>

        <div class="row">
            <div class="col-sm-6 form-group">
                <label to="data-picker">Data da Transferência</label>
                <datepicker
                    v-model="data_alta_semformatacao"
                    :format="formatoData"
                    :disabled="dateDisabled"
                    language="pt-br"
                    id="data-picker"
                    calendar-button
                    calendar-button-icon="fa fa-calendar"
                    >
                </datepicker>
            </div>

            <div class="col-sm-6 form-group">
                <label>Hora da Transferência</label>
                <input class="form-control" type="time" v-model="hora">
                <small v-if="hora == ''" class="text-danger">preenchimento obrigatório</small>
            </div>
        </div>
       
        <button type="button" class="btn btn-primary" @click="validaSessao('transferirLeito')">Transferir Leito</button>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from "moment"
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    props: {
        dados: Object
    },
    mixins: [
        validaSessao
    ],
    components: {
        Datepicker
    },
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
        leitoTransferencia () {
            return this.$store.getters['transferir/getLeitoTransferencia']
        }
    },
    mounted () {
        let hora = new Date().getHours()
        let min = new Date().getMinutes()
        if (hora < 10) hora = '0' + hora
        if (min < 10) min = '0' + min
        
        this.hora = hora + ':' +  min

        this.desabilitaDatas()
    },
    data () {
        return {
            hora: '',
            formatoData: 'dd/MM/yyyy',
            data_alta_semformatacao: new Date(),
            dateDisabled: {
                ranges: [
                    {
                        from: new Date(1990, 11, 25),
                        to: new Date()
                    },
                    {
                        from: new Date(),
                        to: new Date(2040, 2, 25)
                    }
                ]
            }
        }
    },
    methods: {
        formatadata (date) {
            return moment(date).format("YYYY-MM-DD")
        },
        desabilitaDatas () {
            if (this.leitoTransferencia && this.dados.dataHoraUltimaMovimentacao && this.leitoTransferencia.dataHoraUltimaMovimentacao) {
                 console.log('op1')
                let dataum = new Date(
                    parseInt(this.dados.dataHoraUltimaMovimentacao.substr(6,4)),
                    (parseInt(this.dados.dataHoraUltimaMovimentacao.substr(3,2)) - 1),
                    parseInt(this.dados.dataHoraUltimaMovimentacao.substr(0,2)),
                )
                let datadois = new Date(
                    parseInt(this.leitoTransferencia.dataHoraUltimaMovimentacao.substr(6,4)),
                    (parseInt(this.leitoTransferencia.dataHoraUltimaMovimentacao.substr(3,2)) - 1),
                    parseInt(this.leitoTransferencia.dataHoraUltimaMovimentacao.substr(0,2)),
                )

                dataum.getTime() > datadois.getTime() ?
                    this.dateDisabled.ranges[0]['to'] = dataum :
                    this.dateDisabled.ranges[0]['to'] = datadois
            }
            else if (this.leitoTransferencia && this.dados.dataHoraUltimaMovimentacao == '' && this.leitoTransferencia.dataHoraUltimaMovimentacao) {
                this.dateDisabled.ranges[0]['to'] = new Date(
                    parseInt(this.leitoTransferencia.dataHoraUltimaMovimentacao.substr(6,4)),
                    (parseInt(this.leitoTransferencia.dataHoraUltimaMovimentacao.substr(3,2)) - 1),
                    parseInt(this.leitoTransferencia.dataHoraUltimaMovimentacao.substr(0,2)),
                )
            }

        },
        transferirLeito () {
            if (this.hora.length < 5) return
            let datahora = this.formatadata(this.data_alta_semformatacao) + ' ' + this.hora

            let dados = {
                cns: this.leitoTransferencia.pacienteCns,
                codigoEnfermariaOrigem: this.leitoTransferencia.leitoCodigoEnfermaria,
                codigoLeitoOrigem: this.leitoTransferencia.leitoCodigo,
                codigoEnfermariaDestino: this.dados.leitoCodigoEnfermaria,
                codigoLeitoDestino: this.dados.leitoCodigo,
                dataHoraAltaLeito: datahora
            }

            this.$emit('transferir', dados)
        }
    }
}
</script>